import { createSlice } from "@reduxjs/toolkit";
import { FirestoreService } from "../../api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../api/firebase/references";
import { FormConfigModel } from "../../data-model/formConfigModel";

interface FormConfigState {
  formConfigs: FormConfigModel[];
  loading: boolean;
  error: string | null;
  unsubscribe?: () => void;
}

const initialState: FormConfigState = {
  formConfigs: [],
  loading: false,
  error: null,
  unsubscribe: undefined,
};

const formConfigSlice = createSlice({
  name: "formConfig",
  initialState,
  reducers: {
    resetFormConfig(state) {
      state.formConfigs = [];
      state.loading = false;
      state.error = null;
      state.unsubscribe = undefined;
    },
    setFormConfigs(state, action) {
      state.formConfigs = action.payload;
      state.loading = false;
      state.error = null;
      state.unsubscribe = () => {};
    },
    setLoading(state, action) {
      state.loading = action.payload;
      state.unsubscribe = undefined;
    },
    setError(state, action) {
      state.error = action.payload;
      state.loading = false;
      state.unsubscribe = undefined;
    },
    setUnsubscribe(state, action) {
      state.unsubscribe = action.payload;
    },
  },
});

export const {
  setFormConfigs,
  setLoading,
  setError,
  resetFormConfig,
  setUnsubscribe,
} = formConfigSlice.actions;

export const fetchFormConfigfromFirebase = () => async (dispatch) => {
  dispatch(setLoading(true));
  const collectionPath = FirestoreCollectionReference.cmmFormConfig();
  console.log("[formConfigSlice] Fetching form configs from:", collectionPath);
  try {
    const unsubscribe =
      FirestoreService.listenToQueryCollection<FormConfigModel>(
        collectionPath,
        (formConfigs) => {
          console.log(
            "[formConfigSlice] Received form configs:",
            formConfigs?.length ?? 0,
          );
          if (formConfigs?.length > 0) {
            console.log("[formConfigSlice] All docs summary:");
            formConfigs.forEach((doc, i) => {
              console.log(
                `  [${i}] id="${doc.id}", has data.formTitle="${doc?.data?.formTitle}", keys=${Object.keys(doc).join(",")}`,
              );
            });
          }
          if (formConfigs && formConfigs.length > 0) {
            dispatch(setFormConfigs(formConfigs));
          } else {
            console.warn(
              "[formConfigSlice] No form configs found in collection",
            );
            dispatch(setFormConfigs([]));
          }
          dispatch(setUnsubscribe(unsubscribe));
        },
        (error) => {
          console.error("[formConfigSlice] Listener error:", error);
          dispatch(setError(error.message));
        },
      );

    return unsubscribe;
  } catch (error: unknown) {
    console.error("[formConfigSlice] Fetch error:", error);
    if (error instanceof Error) {
      dispatch(setError(error.message));
    }
  } finally {
    dispatch(setLoading(false));
  }
};

export default formConfigSlice.reducer;
